import { render, staticRenderFns } from "./MessageReceiveModal.vue?vue&type=template&id=408b2f16&scoped=true&"
import script from "./MessageReceiveModal.vue?vue&type=script&lang=ts&"
export * from "./MessageReceiveModal.vue?vue&type=script&lang=ts&"
import style0 from "./MessageReceiveModal.vue?vue&type=style&index=0&id=408b2f16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408b2f16",
  null
  
)

export default component.exports